// extracted by mini-css-extract-plugin
module.exports = {"page":"EL-z","cartModal":"FL-z","checkout":"GL-z","placeholder":"HL-z","account":"IL-z"};